import { Input } from "components/ui/inputs/Input"
import { DimensionInputs } from "components/ui/inputs/DimensionInputs/DimensionInputs"
import { H4 } from "components/ui/typography/titles/Titles"
import type { TDimensions } from "types/modelNumbers.type"
import style from "./Dimensions.module.scss"

const { dimensions: dimensionsStyle, inputBlock, title } = style

type Props = {
	dimensions: TDimensions
	onDimensionsChange: (dimensions: TDimensions) => void
	showValidation: boolean
}

export const Dimensions = ({ dimensions, onDimensionsChange, showValidation }: Props) => {
	const addHandle = (field: keyof Pick<TDimensions, "width" | "height" | "depth">, value: string) => {
		onDimensionsChange({ ...dimensions, [field]: [...dimensions[field], value] })
	}

	const removeHandle = (field: keyof Pick<TDimensions, "width" | "height" | "depth">, value: string) => {
		onDimensionsChange({ ...dimensions, [field]: dimensions[field].filter((v) => v !== value) })
	}

	return (
		<div className={dimensionsStyle}>
			<H4 className={title}>Dimensions</H4>
			<DimensionInputs
				label="Width, in"
				values={dimensions.width}
				onAdd={(value) => addHandle("width", value)}
				onRemove={(value) => removeHandle("width", value)}
				hasError={showValidation && dimensions.width.length === 0}
			/>
			<DimensionInputs
				label="Height, in"
				values={dimensions.height}
				onAdd={(value) => addHandle("height", value)}
				onRemove={(value) => removeHandle("height", value)}
				hasError={showValidation && dimensions.height.length === 0}
			/>
			<DimensionInputs
				label="Depth, in"
				values={dimensions.depth}
				onAdd={(value) => addHandle("depth", value)}
				onRemove={(value) => removeHandle("depth", value)}
				hasError={showValidation && dimensions.depth.length === 0}
			/>
			<div className={inputBlock}>
				<span>
					Avg size, in<sup>3</sup>
				</span>
				<Input
					value={dimensions.avg_size}
					onChange={(e) => onDimensionsChange({ ...dimensions, avg_size: e.target.value })}
					status={showValidation && !dimensions.avg_size.trim() ? "error" : undefined}
				/>
			</div>
		</div>
	)
}
